export default __webpack_public_path__ + "static/tech-nation-1--mobile-0ac7dc53e03542fd845fb0285f1307b5.webp";